/**
 * The events currently supported by our GTM implementation.
 *
 * Naming is inspired by the gtag.js events Google Analytics suggests:
 * https://developers.google.com/analytics/devguides/collection/gtagjs/events#default_google_analytics_events
 */
export enum gtmEventNames {
  /** E-Commerce purchase */
  purchase = 'purchase',
  /** Custom GA event */
  gaEvent = 'ga_event'
}
